import { createSelector } from '@reduxjs/toolkit';
import { State } from '../../../store/state';

export const coursesSelector = (state: State) => state.course.courses;
export const courseSelector = (state: State) => state.course.course;
export const childCoursesSelector = (state: State) => state.course.childCourses;
export const ratingsSelector = (state: State) => state.course.ratings;
export const ratingSelector = (state: State) => state.course.rating;
export const reportsSelector = (state: State) => state.course.reports;
export const reportSelector = (state: State) => state.course.report;
export const categoriesSelector = (state: State) => state.course.categories;
export const selectedSelector = (state: State) => state.course.selected;
export const studentsSelector = (state: State) => state.course.students;
export const forumStudentsSelector = (state: State) => state.course.forumStudents;
export const modulesSelector = (state: State) => state.course.modules;
export const modulesStatusSelector = (state: State) => state.course.modulesStatus;
export const moduleSelector = (state: State) => state.course.module;
export const forumSubjectsSelector = (state: State) => state.course.forumSubjects;
export const forumSubjectSelector = (state: State) => state.course.forumSubject;
export const calendarEventsSelector = (state: State) => state.course.calendarEvents;
export const currentClassIdSelector = (state: State) => state.course.currentClassId;
export const expandedModulesSelector = (state: State) => state.course.expandedModules;
export const readForumSubjectsSelector = (state: State) => state.course.readForumSubjects;
export const classCommentsSelector = (state: State) => state.course.classComments;
export const classCommentCountSelector = (state: State) => state.course.classCommentCount;
export const forumCommentsSelector = (state: State) => state.course.forumComments;
export const forumCommentCountSelector = (state: State) => state.course.forumCommentCount;
export const viewedSelector = (state: State) => state.course.viewed;
export const optionsSelector = (state: State) => state.course.options;
export const totalSelector = (state: State) => state.course.total;
export const noMoreSelector = (state: State) => state.course.noMore;
export const pageSelector = (state: State) => state.course.page;
export const calculatorOptionsSelector = (state: State) => state.course.positionCalculatorOptions;
export const errorCodeSelector = (state: State) => state.course.errorCode;
export const alliancesSelector = (state: State) => state.course.alliances;

const positionCalculatorValuesIdsSelector = (state: State) => state.course.positionCalculatorValues.ids;
const positionCalculatorValuesEntitiesSelector = (state: State) => state.course.positionCalculatorValues.entities;
export const positionCalculatorValuesSelector = createSelector(
  [positionCalculatorValuesIdsSelector, positionCalculatorValuesEntitiesSelector],
  (ids, entities) => ids.map((id) => entities[id])
);